import { useState, useEffect, useMemo } from "react";
import MachineFact from "system/types/interfaces/MachineFact";
import { toFormatedDate, getUtcOffset } from "system/libraries/utilities";

interface IProps {
  facts: MachineFact[];
  code: string;
}

const EndpointDetailBootUpTime = ({ facts, code }: IProps) => {
  const value = facts?.find(f => f.code === code)?.value;

  const targetDate = useMemo(() => {
    if (!value) return null;
    const parsed = new Date(value);
    return isNaN(parsed.getTime()) ? null : parsed;
  }, [value]);

  const [uptime, setUptime] = useState("");

  useEffect(() => {
    if (!targetDate) return;

    const computeUptime = () => {
      const diffMs = Date.now() - targetDate.getTime();
      const days = Math.floor(diffMs / 86400000);
      const hours = Math.floor((diffMs % 86400000) / 3600000);
      const minutes = Math.floor((diffMs % 3600000) / 60000);
      const seconds = Math.floor((diffMs % 60000) / 1000);

      const parts = [];
      if (days > 0) parts.push(`${days} day${days !== 1 ? "s" : ""}`);
      parts.push(`${hours} hour${hours !== 1 ? "s" : ""}`);
      parts.push(`${minutes} minute${minutes !== 1 ? "s" : ""}`);
      parts.push(`${seconds} second${seconds !== 1 ? "s" : ""}`);
      return parts.join(", ") + " since last boot time";
    };

    setUptime(computeUptime());
    const interval = setInterval(() => setUptime(computeUptime()), 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  if (!targetDate) return null;

  return (
    <>
      <tr>
        <td><span className="endpoint-fact-code">Last boot time</span></td>
        <td><span className="endpoint-fact-value ms-2">: {toFormatedDate(targetDate.toString())} (Device local time UTC{getUtcOffset(targetDate)})</span></td>
      </tr>
      <tr>
        <td><span className="endpoint-fact-code">Up time</span></td>
        <td><span className="endpoint-fact-value ms-2">: {uptime}</span></td>
      </tr>
    </>
  );
};

export default EndpointDetailBootUpTime;
